var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'form-field',
    {
      'form-field--label-left': _vm.labelLeft,
      'form-field--design-new': _vm.design === 'new'
    }
  ],style:({ marginTop: `${_vm.marginTop}px`, marginBottom: `${_vm.marginBottom}px` })},[(_vm.label)?_c('div',{class:['form-field__header', { 'form-field__header--label-additional': _vm.$slots['label-additional'] }]},[_c('label',{staticClass:"form-field__label",attrs:{"for":_vm.labelFor}},[_c('span',{staticClass:"form-field__text"},[_vm._v(_vm._s(_vm.label))]),(_vm.required)?_c('sup',{staticClass:"form-field__sup"},[_vm._v("*")]):_vm._e()]),_vm._t("label-additional")],2):_vm._e(),_vm._t("default"),(_vm.$slots.error)?_c('div',{staticClass:"form-field__errors"},[_vm._t("error")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }